import React from 'react';
import PropTypes from 'prop-types';
import styles from './RiskLevelSliderV4.css';

function RiskLevelSliderV4({ riskPercent, levels = ['low', 'moderate', 'high'], className = '', riskColor = 'var(--error-color)', levelTextColor = 'var(--gray-color)' }) {
    return (
        <div className={`${styles.root} ${className}`.trim()}>
            <div className={styles.trackLine}>
                <div className={styles.trackLineBg} />
                <div className={styles.circle} style={{ '--percent': `${riskPercent || 2}%`, color: riskColor }} />
            </div>
            <div className={styles.levels} style={{ color: levelTextColor, gridTemplateColumns: `repeat(${levels.length}, 1fr)` }}>
                {levels.map(level => <span key={level}>{level}</span>)}
            </div>
        </div>
    );
}

RiskLevelSliderV4.propTypes = {
    riskPercent: PropTypes.number,
    levels: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    riskColor: PropTypes.string,
    levelTextColor: PropTypes.string
};

export {
    RiskLevelSliderV4
};
